import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export interface PolicyState {
  survey: Array<{
    issueId?: number;
    completed?: boolean;
  }>;
}

const initialState: PolicyState = {
  survey: [],
};
export const PolicyAdapter = createEntityAdapter<PolicyState>();

const policySlice = createSlice({
  name: 'policy',
  initialState: PolicyAdapter.getInitialState(initialState),
  reducers: {
    addSurvey: (state, action) => {
      return {
        ...state,
        survey: state.survey?.length
          ? [...state.survey, action.payload]
          : [action.payload],
      };
    },
    removeSurvey: (state, action) => {
      return {
        ...state,
        survey: state.survey.filter(
          ({ issueId }) => issueId !== action.payload,
        ),
      };
    },
    completeSurvey: (state, action) => {
      return {
        ...state,
        survey: state.survey.map((surveyItem) =>
          surveyItem.issueId === action.payload
            ? { ...surveyItem, completed: true }
            : surveyItem,
        ),
      };
    },
  },
});

export default policySlice.reducer;
export const { addSurvey, completeSurvey, removeSurvey } = policySlice.actions;
